import { z } from 'zod';

export const CollaboratorCommissionRoleSchema = z.enum(['MECHANIC', 'SELLER']);
export const CollaboratorCommissionBaseSchema = z.enum(['SERVICE', 'PART']);
export const CollaboratorCommissionResolvedFromSchema = z.enum(['COLLABORATOR', 'PLACE', 'TENANT']);

export const CollaboratorCommissionRateQuerySchema = z.object({
  role: CollaboratorCommissionRoleSchema,
});

export const SaveCollaboratorCommissionRateBodySchema = z.object({
  role: CollaboratorCommissionRoleSchema,
  serviceRateBps: z.number().nullable().optional(),
  partRateBps: z.number().nullable().optional(),
});

export const CollaboratorCommissionRateBaseSchema = z.object({
  base: CollaboratorCommissionBaseSchema,
  rateBps: z.number().int().positive().nullable(),
  effectiveRateBps: z.number().int().positive().nullable(),
  resolvedFrom: CollaboratorCommissionResolvedFromSchema,
});

export const CollaboratorCommissionRateResponseSchema = z.object({
  placeId: z.uuid(),
  userId: z.uuid(),
  role: CollaboratorCommissionRoleSchema,
  bases: z.array(CollaboratorCommissionRateBaseSchema),
});

export type CollaboratorCommissionRateQuery = z.infer<typeof CollaboratorCommissionRateQuerySchema>;
export type SaveCollaboratorCommissionRateBody = z.infer<
  typeof SaveCollaboratorCommissionRateBodySchema
>;
export type CollaboratorCommissionRateResponse = z.infer<
  typeof CollaboratorCommissionRateResponseSchema
>;
